export class ResearchModel {
  currentPage: number = 1;
  perPage: number = 50;
  lastPage: number = 1;
  total: number = 0;
}
